import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'player-skip-forward', 'PlayerSkipForward', [["path",{"d":"M4 5v14l12 -7l-12 -7"}],["path",{"d":"M20 5l0 14"}]]);